import { AppEntities } from "src/config/entities";
import { IListViewField } from "src/components/Shared/ILIstViewField";
import { NewDocumentListView } from "src/components/Shared/NewDocumentListView";
import { ListView } from "src/components/Shared/ListViews/ListView";
import { DocumentListViewToolbar } from "src/components/Shared/ListViews/DocumentListViewToolbar";
import { DocumentListViewDefaultToolbarButtons } from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { ListviewToolbarSubmenuButton } from "src/components/Shared/ListViews/ListviewToolbarSubmenuButton";
import { ListviewToolbarMoreActions } from "src/components/Shared/ListViews/ListviewToolbarMoreActions";

export const ImportsList = () => {
  const fields: IListViewField[] = [
    {
        fieldName: "id",
        title: "Id",
        fieldType: "string",
    },
    {
        fieldName: "companyName",
        title: "Company",
        fieldType: "string",
    },
    {
        fieldName: "vendorName",
        title: "Vendor",
        fieldType: "string",
    },
    {
      fieldName: "divisionName",
      title: "Division",
      fieldType: "string",
  },
    {
        fieldName: "totalAmount",
        title: "Total Amount",
        fieldType: "number",
        format: {
            type: "fixedPoint",
            precision: 2,
        },
    },
];
  return (
    <>
      <ListView fields={fields} entity={AppEntities.Imports} createMoreActions={[]}>
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons>
            <ListviewToolbarSubmenuButton />
          </DocumentListViewDefaultToolbarButtons>
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>{" "}
    </>
  );
};
